<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div class="max-w-md w-full">
      <!-- Logo -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-20 h-20 bg-takas-sari rounded-2xl shadow-lg mb-4">
          <span class="text-3xl font-black text-takas-koyu">T</span>
        </div>
        <h1 class="text-4xl font-bold text-gray-900 mb-2">TakasX</h1>
        <p class="text-gray-500">Yeni hesap oluştur</p>
      </div>

      <!-- Kayıt Formu -->
      <div class="bg-white rounded-2xl shadow-xl p-8">
        <form @submit.prevent="handleSignUp">
          <div class="mb-4">
            <label class="block text-gray-700 font-semibold mb-2">Ad Soyad</label>
            <input 
              v-model="fullName" 
              type="text" 
              minlength="3"
              maxlength="50"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-takas-sari focus:ring-2 focus:ring-takas-sari focus:ring-opacity-20 transition"
              required
            />
            <p class="text-xs text-gray-500 mt-1">En az 3, en fazla 50 karakter</p>
          </div>
          
          <div class="mb-4">
            <label class="block text-gray-700 font-semibold mb-2">E-posta</label>
            <input 
              v-model="email" 
              type="email" 
              minlength="6"
              maxlength="100"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-takas-sari focus:ring-2 focus:ring-takas-sari focus:ring-opacity-20 transition"
              required
            />
            <p class="text-xs text-gray-500 mt-1">En az 6, en fazla 100 karakter</p>
          </div>
          
          <div class="mb-4">
            <label class="block text-gray-700 font-semibold mb-2">Şifre</label>
            <input 
              v-model="password" 
              type="password" 
              minlength="6"
              maxlength="50"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-takas-sari focus:ring-2 focus:ring-takas-sari focus:ring-opacity-20 transition"
              required
            />
            <p class="text-xs text-gray-500 mt-1">En az 6, en fazla 50 karakter</p>
          </div>
          
          <div class="mb-6">
            <label class="block text-gray-700 font-semibold mb-2">Şifre Tekrar</label>
            <input 
              v-model="confirmPassword" 
              type="password" 
              minlength="6"
              maxlength="50"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-takas-sari focus:ring-2 focus:ring-takas-sari focus:ring-opacity-20 transition"
              required
            />
          </div>
          
          <button 
            type="submit" 
            class="w-full bg-takas-sari text-takas-koyu font-bold py-3 rounded-xl hover:bg-opacity-90 transition transform hover:scale-[1.02] shadow-lg"
          >
            Kayıt Ol
          </button>
        </form>

        <div class="mt-6 text-center">
          <router-link to="/signin" class="text-takas-sari font-semibold hover:underline">
            Zaten hesabın var mı? Giriş Yap
          </router-link>
        </div>

        <div v-if="error" class="mt-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-xl text-sm">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUp',
  data() {
    return {
      fullName: '',
      email: '',
      password: '',
      confirmPassword: '',
      error: ''
    }
  },
  methods: {
    handleSignUp() {
      if (this.fullName.length < 3) {
        this.error = 'Ad Soyad en az 3 karakter olmalıdır'
        return
      }
      if (this.email.length < 6) {
        this.error = 'E-posta en az 6 karakter olmalıdır'
        return
      }
      if (this.password.length < 6) {
        this.error = 'Şifre en az 6 karakter olmalıdır'
        return
      }
      if (this.password !== this.confirmPassword) {
        this.error = 'Şifreler eşleşmiyor'
        return
      }
      if (this.fullName && this.email && this.password) {
        localStorage.setItem('user', JSON.stringify({ 
          email: this.email, 
          name: this.fullName 
        }))
        this.$router.push('/')
      } else {
        this.error = 'Lütfen tüm alanları doldurun'
      }
    }
  }
}
</script>